import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Component({
    selector: 'sub-grid-sign, [sub-grid-sign]',
    template: '',
    styleUrls: ['sub-grid-sign.component.scss'],
    standalone: false
})
export class SubGridSignComponent {

  @HostBinding('class.expanded')
  @Input()
  isExpanded: boolean;

  @Output()
  isExpandedChange = new EventEmitter<boolean>();

  @HostListener('click', ['$event']) onClick($event: Event) {
    $event.stopPropagation();
    this.isExpanded = !this.isExpanded;
    this.isExpandedChange.emit(this.isExpanded);
  }
}
